import { WarehouseClass } from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import { MTT_WAREHOUSE_TYPE_EXTENSION_PROPERTY, MTT_WAREHOUSE_TYPE_FACTORY, MTT_WAREHOUSE_TYPE_RETAIL } from '../constants';
import { getStringProperty } from './extension-properties-helpers';

const normalizeValue = (value?: string): string | undefined => {
    const normalizedValue = value?.trim()?.toUpperCase();
    return normalizedValue ? normalizedValue : undefined;
};

export const getWarehouseTypeForUnitOfMeasure = (requestedUnitOfMeasure?: string, defaultUnitOfMeasure?: string): string | undefined => {
    const productDefaultUom = normalizeValue(defaultUnitOfMeasure);
    const productCurrentUom = normalizeValue(requestedUnitOfMeasure ?? defaultUnitOfMeasure);

    if (!productDefaultUom || !productCurrentUom) {
        return undefined;
    }

    return productCurrentUom === productDefaultUom ? MTT_WAREHOUSE_TYPE_RETAIL : MTT_WAREHOUSE_TYPE_FACTORY;
};

export const filterWarehousesByType = (warehouses: WarehouseClass[] = [], warehouseType?: string): WarehouseClass[] => {
    const normalizedWarehouseType = normalizeValue(warehouseType);
    if (!normalizedWarehouseType) {
        return warehouses;
    }

    return warehouses.filter(
        warehouse =>
            normalizeValue(getStringProperty(warehouse?.ExtensionProperties, MTT_WAREHOUSE_TYPE_EXTENSION_PROPERTY))?.includes(
                normalizedWarehouseType
            ) === true
    );
};
